<template>
	<div v-if="prefetch">
		<slot></slot>
	</div>
</template>

<script>
import { PrefetchMixin } from "../../mixins/prefetch.js"; 

export default {
    name: "prefetch",

	mixins: [
		PrefetchMixin
	]
};
</script>